export const teamMemberPhoto = 'https://static.tickchak.co.il/images/userProfile.jpg';